/**
 * @generated SignedSource<<1ee718e60bc978aaf1bad1f3ee6373c6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpLayoutAtomicElementKey = "ANNOUNCEMENT" | "CONNECT" | "EDITOR" | "FORGE" | "HEADING" | "HERO" | "IMAGE" | "NO_CONTENT" | "PARAGRAPH" | "PORTALS_LIST" | "SEARCH" | "SUGGESTED_REQUEST_FORMS_LIST" | "TOPICS_LIST" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type elementErrorBoundaryFragment$data = {
  readonly __typename: "HelpLayoutAnnouncementElement";
  readonly elementType: {
    readonly key: HelpLayoutAtomicElementKey | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "elementErrorBoundaryFragment";
} | {
  readonly __typename: "HelpLayoutConnectElement";
  readonly elementType: {
    readonly key: HelpLayoutAtomicElementKey | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "elementErrorBoundaryFragment";
} | {
  readonly __typename: "HelpLayoutEditorElement";
  readonly elementType: {
    readonly key: HelpLayoutAtomicElementKey | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "elementErrorBoundaryFragment";
} | {
  readonly __typename: "HelpLayoutForgeElement";
  readonly elementType: {
    readonly key: HelpLayoutAtomicElementKey | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "elementErrorBoundaryFragment";
} | {
  readonly __typename: "HelpLayoutHeroElement";
  readonly elementType: {
    readonly key: HelpLayoutAtomicElementKey | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "elementErrorBoundaryFragment";
} | {
  readonly __typename: "HelpLayoutNoContentElement";
  readonly elementType: {
    readonly key: HelpLayoutAtomicElementKey | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "elementErrorBoundaryFragment";
} | {
  readonly __typename: "HelpLayoutPortalsListElement";
  readonly elementType: {
    readonly key: HelpLayoutAtomicElementKey | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "elementErrorBoundaryFragment";
} | {
  readonly __typename: "HelpLayoutSuggestedRequestFormsListElement";
  readonly elementType: {
    readonly key: HelpLayoutAtomicElementKey | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "elementErrorBoundaryFragment";
} | {
  readonly __typename: "HelpLayoutTopicsListElement";
  readonly elementType: {
    readonly key: HelpLayoutAtomicElementKey | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "elementErrorBoundaryFragment";
} | {
  readonly __typename: "QueryError";
  readonly identifier: string | null | undefined;
  readonly " $fragmentType": "elementErrorBoundaryFragment";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "elementErrorBoundaryFragment";
};
export type elementErrorBoundaryFragment$key = {
  readonly " $data"?: elementErrorBoundaryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"elementErrorBoundaryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "concreteType": "HelpLayoutAtomicElementType",
    "kind": "LinkedField",
    "name": "elementType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "key"
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "elementErrorBoundaryFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "HelpLayoutAnnouncementElement"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "HelpLayoutEditorElement"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "HelpLayoutHeroElement"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "HelpLayoutPortalsListElement"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "HelpLayoutTopicsListElement"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "HelpLayoutSuggestedRequestFormsListElement"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "HelpLayoutNoContentElement"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "HelpLayoutForgeElement"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "HelpLayoutConnectElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "identifier"
        }
      ],
      "type": "QueryError"
    }
  ],
  "type": "HelpLayoutElement",
  "abstractKey": "__isHelpLayoutElement"
};
})();

(node as any).hash = "4539aa2430386c2a8ebd47194a98dee5";

export default node;
